export default "__VITE_ASSET__oeBMpAVK__"